import { Action, Dispatch } from "redux";
import initialState from "../initialState";
import { NotificationActions } from "./notification/notification-actions";
import { AppDispatch } from "./index";
import { getApi } from "../api/ApiProvider";
import {
  default as StoreModel,
  LoadedResource,
  LoadedSingleResource,
} from "./StoreModel";
import { Company } from "../api/model";

export enum CompanyActionTypes {
  FETCH_REQUEST = "[COMPANY][LIST] Request",
  FETCH_RESPONSE = "[COMPANY][LIST] Response",
  FETCH_ERROR = "[COMPANY][ERROR] error",
  ADD_USER_REQUEST = "[COMPANY][ADD] Request",
  ADD_USER_RESPONSE = "[COMPANY][ADD] Response",
  ADD_USER_ERROR = "[COMPANY][ADD] Error",
}

export interface CompanyState {
  data: LoadedResource<Company>;
  add: LoadedSingleResource<Company>;
}

export default (
  state: CompanyState = initialState.company,
  action?: Action<CompanyActionTypes> & { payload: any }
): CompanyState => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case CompanyActionTypes.FETCH_REQUEST:
      return {
        ...state,
        data: StoreModel.fetching(),
      };

    case CompanyActionTypes.FETCH_RESPONSE:
      return {
        ...state,
        data: StoreModel.result(action.payload),
      };

    case CompanyActionTypes.FETCH_ERROR:
      return {
        ...state,
        data: StoreModel.error(action.payload),
      };

    case CompanyActionTypes.ADD_USER_REQUEST:
      return {
        ...state,
        add: StoreModel.fetchingSingle(),
      };
    case CompanyActionTypes.ADD_USER_RESPONSE:
      if (StoreModel.isLoaded(state.data)) {
        return {
          ...state,
          data: {
            ...state.data,
            data: state.data.data.concat(action.payload),
          },
          add: StoreModel.resultSingle(action.payload),
        };
      }
      return {
        ...state,
        add: StoreModel.resultSingle(action.payload),
      };
    case CompanyActionTypes.ADD_USER_ERROR:
      return {
        ...state,
        add: StoreModel.errorSingle(action.payload),
      };

    default:
      return state;
  }
};

export class CompanyActions {
  save(data: any, admin?: any) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();
      const branchDefault = {
        name: "Central",
        lat: -25.301878,
        lng: -57.5844456,
        street1: "central",
        street2: "",
        observation: "",
        number: "",
        companyId: 0,
      };

      dispatch({ type: CompanyActionTypes.ADD_USER_REQUEST });

      if (admin) {
        getApi()
          .admin()
          .add(admin)
          .then((adminResponse) => {
            getApi()
              .company()
              .save({
                ...data,
                adminId: adminResponse.id,
              })
              .then((response) => {
                branchDefault.companyId = response.id;

                getApi()
                  .branch()
                  .save(branchDefault)
                  .then((companyResponse) => {
                    const branch = companyResponse.id;

                    getApi()
                      .admin()
                      .updateBranch(adminResponse.id, branch)
                      .then((updateResponse: any) => {
                        console.log(
                          "Actualizado el admin:  --> ",
                          updateResponse
                        );
                      });
                  });

                dispatch(notif.addSuccess("Empresa", "Creación correcta"));
                dispatch({
                  type: CompanyActionTypes.ADD_USER_RESPONSE,
                  payload: response,
                });
              })
              .catch((err) => {
                dispatch(notif.addError("Empresa", "Ocurrio un error"));
                dispatch({
                  type: CompanyActionTypes.ADD_USER_ERROR,
                  payload: err,
                });
              });
          })
          .catch((err) => {
            dispatch(notif.addError("Empresa", "Ocurrio un error"));
            dispatch({ type: CompanyActionTypes.ADD_USER_ERROR, payload: err });
          });
      } else {
        getApi()
          .company()
          .save({
            ...data,
          })
          .then(() => {
            dispatch(notif.addSuccess("Empresa", "Guardado correctamente"));
            dispatch(this.fetch());
          })
          .catch((err) => {
            dispatch(notif.addError("Empresa", "Ocurrio un error"));
            dispatch({
              type: CompanyActionTypes.ADD_USER_ERROR,
              payload: err,
            });
          });
      }
    };
  }

  fetch() {
    return (dispatch: Dispatch) => {
      dispatch({ type: CompanyActionTypes.FETCH_REQUEST });
      getApi()
        .company()
        .list()
        .then((data) => {
          dispatch({ type: CompanyActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: CompanyActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/company.ts